<div id="todo" class="page-layout carded left-sidebar inner-scroll">

    <fuse-sidebar class="sidebar" name="menu-main-sidebar" position="left" lockedOpen="gt-md">
        <menu-main-sidebar></menu-main-sidebar>
    </fuse-sidebar>

    <div class="center">

        <div class="mb-24" fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
            <form class="mat-card mat-elevation-z4 p-24 mr-24" fxLayout="column" fxLayoutAlign="start"
                  fxFlex="1 0 auto" name="form" [formGroup]="form" (ngSubmit)="onSubmit()">

                <div class="h2 mb-24">{{'Menu data'|translate}}</div>

                <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                    <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                        <mat-label>{{'Name'|translate}}</mat-label>
                        <input matInput formControlName="name" required>
                        <mat-error>{{'Name is required!'|translate}}</mat-error>
                    </mat-form-field>
                </div>

                <div *ngIf="menu.id">
                    <a (click)="showCreateMenuItemDialog(menu, null, null)" mat-raised-button color="primary">{{'Add main node'|translate}}</a>

                    <ul>
                        <ng-template #recursiveList let-list>
                            <li *ngFor="let item of menu.items">
                                <a (click)="showCreateMenuItemDialog(menu, item.parent, item)">{{item.name}}</a> <a (click)="showCreateMenuItemDialog(menu, item, null)">+</a>
                                <ul *ngIf="item.items.length > 0">
                                    <ng-container *ngTemplateOutlet="recursiveList; context:{ $implicit: item.items }"></ng-container>
                                </ul>
                            </li>
                        </ng-template>
                        <ng-container *ngTemplateOutlet="recursiveList; context:{ $implicit: menu.items }"></ng-container>
                    </ul>
                </div>

<!--                <div formArrayName="items" *ngFor="let menuItem of menuItems().controls; index as i">-->
<!--                    <div [formGroupName]="i">-->
<!--                        <mat-form-field appearance="outline" fxFlex="5" class="pr-4">-->
<!--                            <mat-label>{{'Or.'|translate}}</mat-label>-->
<!--                            <input matInput formControlName="order" required>-->
<!--                            <mat-error>{{'Order is required!'|translate}}</mat-error>-->
<!--                        </mat-form-field>-->

<!--                        <mat-form-field appearance="outline" fxFlex="20" class="pr-4">-->
<!--                            <mat-label>{{'Name'|translate}}</mat-label>-->
<!--                            <input matInput formControlName="name" required>-->
<!--                            <mat-error>{{'Name is required!'|translate}}</mat-error>-->
<!--                        </mat-form-field>-->
<!--                        <mat-form-field appearance="outline" fxFlex="20" class="pr-4">-->
<!--                            <mat-label>{{'Tag'|translate}}</mat-label>-->
<!--                            <input matInput formControlName="tagTitle" required>-->
<!--                            <mat-error>{{'Tag is required!'|translate}}</mat-error>-->
<!--                        </mat-form-field>-->
<!--                        <button (click)="removeMenuItem(i)" mat-raised-button color="warn">{{'Remove'|translate}}</button>-->
<!--                    </div>-->
<!--                </div>-->

<!--                <button type="button" (click)="addMenuItem()" mat-raised-button color="primary">{{'Add menu item'|translate}}</button>-->

                <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                    <div fxLayout="row" fxLayoutAlign="center center">
                        <button mat-raised-button type="submit" color="accent">
                            {{'Save'|translate}}
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
